/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import PasscodeInput from "../../../PasscodeInput";
import StyledButton from "../../../StyledButton";
import { SignupFormSection } from "../../Form";
import {
  PasscodeButtonsWrapper,
  PasscodeContainer,
  PasscodeProps,
  PasscodeWrapper,
} from "../ThirdForm";

export default function ChoosePasscode({
  setSelectedForm,
  form,
  handleChangeForm,
}: PasscodeProps) {
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  return (
    <PasscodeContainer>
      <PasscodeWrapper>
        <PasscodeInput
          passcode={form.choosePasscode}
          handleChangePasscode={(newPassCode) =>
            handleChangeForm("choosePasscode", newPassCode)
          }
          error={error !== ""}
          handleChangeError={(newError) => setError(newError)}
        />
      </PasscodeWrapper>

      <PasscodeButtonsWrapper>
        <StyledButton
          onClick={() =>
            setSelectedForm(SignupFormSection.TemporyPasscodeLearnistic)
          }
          inverted
        >
          Back
        </StyledButton>
        <StyledButton
          disable={form.choosePasscode.includes("")}
          isLoading={isLoading}
          onClick={() => {
            if (form.choosePasscode.includes("")) return;
            setSelectedForm(SignupFormSection.ConfirmPasscodeLearnistic);
          }}
        >
          Next
        </StyledButton>
      </PasscodeButtonsWrapper>
    </PasscodeContainer>
  );
}
